import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'primeng/primeng';
import { AccountService } from '../../service/account/account.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  public form: FormGroup;
  public email: string;
  public promisePass: Promise<any>;
  public msgs: Message[] = [];
  public code: String;
  fieldTextType: boolean = false;

  constructor(
    public translate: TranslateService,
    public route: ActivatedRoute,
    fb: FormBuilder,
    private _router: Router,
    public accountService: AccountService,

  ) {
    this.translate.use('es');

    this.form = fb.group({
      password: new FormControl('', Validators.compose([ Validators.required, Validators.minLength(4) ])),
      password_confirmation: new FormControl('', Validators.compose([ Validators.required, Validators.minLength(4) ]))
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['code'])
        this.code = params['code'];
      else {
        alert('URL no válida');
        this._router.navigateByUrl('/login-candidate');
      }
    });
  }

  public updatePassword(values) {
    event.preventDefault();

    values['code'] = this.code;

    // const d = new Date();
    // const body = {
    //   'new_password': values.password,
    //   'password_change_at': d
    // };


    this.promisePass = this.accountService.passwordReset(values).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push( { severity: 'success', summary: '¡Contraseña actualizada exitosamente!' } );
        });
        alert("¡Contraseña actualizada exitosamente!");
        this._router.navigateByUrl('/login-candidate');
      },
      error => {
        let errorMsg = '';
        if ( error.status === 422 ) {
          this.translate.get('current password invalid').subscribe((res: string) => {
            errorMsg = res;
          });
        }
        if ( error.status === 500 )
          errorMsg = 'Error';

        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'URL expirada, favor repetir el proceso' } );

        alert('URL expirada, favor repetir el proceso');
        this._router.navigateByUrl('/recover');
      }
    );
  }

  toggleFieldTextType(field_password: number) {
    if(field_password == 1)
      this.fieldTextType = !this.fieldTextType;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/change-password/change-password.component.ts